import m from 'mithril'

/**
 * 桌面版表格標題元件
 */
export default class DesktopTableHeader {
    view(vnode) {
        const { showPriceInfo } = vnode.attrs

        const columns = [
            { label: "#", style: { maxWidth: "2%" } },
            { label: "地區" },
            { label: "地址", style: { minWidth: "15%" } },
            { label: "連結" },
            { label: "照片1" },
            { label: "照片2" },
            { label: "廠商" },
            { label: "鷹架" },
            { label: "尺寸" },
            { label: "裁數", style: { minWidth: "10%" } },
            { label: "吊車" },
            { label: "方式" },
            { label: "租金" },
            { label: "窗口" },
            { label: "電話" },
            { label: "備註" },
        ]

        return m(".col-12.p-0", [
            m(".row.w-100.py-2.font-weight-bold.m-0", {
                style: {
                    background: "#A4D5D9",
                    color: "white"
                }
            }, [
                ...columns.map(col =>
                    m(".col.px-0.text-center", col.style ? { style: col.style } : {}, col.label)
                ),
                // 價格欄位 (條件顯示)
                showPriceInfo ? m(".col.px-0.text-center", "價格") : "",
                // 編輯欄位
                m(".col.px-0.text-center", { style: { minWidth: "10%" } }, "編輯"),
            ])
        ])
    }
}
